import { render, staticRenderFns } from "./PlantDropdownItemsDefinition.vue?vue&type=template&id=36fc2296&"
import script from "./PlantDropdownItemsDefinition.vue?vue&type=script&lang=ts&"
export * from "./PlantDropdownItemsDefinition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports